import React from 'react';
import audioFile from '../../../../../assets/audioFile.svg';
import {getDisplayFileName} from "../Utils.ts";
import {useAppStore} from "../../../../../GlobalStore/GlobalStore.ts";

interface AudioProps {
    item: {
        fileContent: string;
        fileName: string;
    };
}

const Audio: React.FC<AudioProps> = ({ item }) => {
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);

    const handleAudioClick = (audioSource: string) => {
        setDynamicStateObj({
            visiblePopup: "enlargedContent",
            enlargedContent: {type: "audio", content: audioSource},
        });
    };

    return (
        <div className="flex-none">
            <div className="my-3 mx-0.5 flex flex-col pt-1 pb-0 bg-neutral-200 dark:bg-neutral-900 items-center w-28 h-22 border border-neutral-800 rounded-lg">
                <button
                    className="mb-0.5 p-1 w-12 h-12 object-contain cursor-pointer"
                    onClick={() => handleAudioClick(item.fileContent)}
                >
                    <img
                        className={"invert dark:invert-0"}
                        src={`${audioFile}`}
                        alt="Message Audio"
                    />
                </button>
                <div
                    className="mb-1.5 text-xs"
                    data-tooltip-id="main-tooltip"
                    data-tooltip-content={item.fileName}
                    data-tooltip-place="top"
                >
                    {getDisplayFileName(item.fileName)}
                </div>
            </div>
        </div>
    );
};

export default Audio;
